import React from "react";
import PropTypes from "prop-types";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import Image from "../global/Image";

/********************************
<Testimonial />
/********************************
Version: 1
Created: 17 08 2023
Updated: 30 09 2023
Author: Richy Pears
/********************************
Used to display animated 
testimonials in the <Testimonial /> 
component

TODO: Make this component fully
accessible with button clicks
/********************************/

const Testimonial = ({ theme, node }) => {
  if (!node) return null; // Escape hatch

  const colour = SmartColour(theme);

  return (
    <div
      className={`flex flex-col md:flex-row gap-10 md:gap-12 items-center justify-center`}
    >
      <div className="w-full md:w-7/12 h-full aspect-3x2">
        {node.image && (
          <Image aspect="3x2" src={node.image} className="w-full rounded-2xl" />
        )}
      </div>
      <div className="w-full md:w-5/12 h-full flex flex-col items-center justify-center gap-5">
        {node.quote && <h3 className="w-full m-0">{node.quote}</h3>}
        {node.copy && (
          <div className="w-full brand-remove-last-margin m-0 text-lg">
            {node.copy}
          </div>
        )}
        <div className="w-full">
          {node.name && (
            <div className="m-0 text-lg font-bold ps-8 relative">
              <span className="absolute left-0">&mdash;</span>
              {node.name}
            </div>
          )}
          {node.role && <div className="m-0 text-base ps-8">{node.role}</div>}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;

Testimonial.defaultProps = {
  theme: "white",
  node: null,
};

Testimonial.propTypes = {
  theme: PropTypes.string,
  node: PropTypes.object,
};
